<ion-nav #nav [animated]="false" [root]="navRoot" [rootParams]="{ selfReference: {} }"></ion-nav>
